import i18n from '../i18n/i18n';
import { formatSessionStatus } from './MessageFormatter';

const FAILED_PAYMENT_STATUS_CODES = ['REJECTED', 'FAILED', 'CANCELLED', 'TIMED_OUT'];

// The message that ends the ?sid= status poll (GET /customer/session/status/{sid}), or null to keep
// polling. After a full page load the in-memory session state is gone and socket events for the
// session are ignored, so the poll alone has to reach a final screen.
export const getSessionStatusPollError = (status: {
  sessionState: { state: number },
  transactionState: { type: string, statusCode: string } | null,
}): string | null => {
  const { sessionState, transactionState } = status;

  if (transactionState
    && (transactionState.type === 'AUTHORIZATION' || transactionState.type === 'PURCHASE')
    && FAILED_PAYMENT_STATUS_CODES.includes(transactionState.statusCode)) {
    return i18n.t('payment_failed');
  }

  if (sessionState.state < 0) {
    return formatSessionStatus(sessionState.state);
  }

  return null;
};
